var map = {
	"./aboutRoute": 8165,
	"./aboutRoute.vue": 8165,
	"./copyrightRoute": 7104,
	"./copyrightRoute.vue": 7104,
	"./homeRoute": 2714,
	"./homeRoute.vue": 2714,
	"./legalNoticeRoute": 749,
	"./legalNoticeRoute.vue": 749,
	"./servicesRoute": 5499,
	"./servicesRoute.vue": 5499
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9555;
module.exports = webpackAsyncContext;